import { Component, OnChanges,Input} from '@angular/core';
import { GenService } from '../../shared/gen-ser.service';
import { DataService } from '../../shared/dataservice.service';
import { TaskLinked,TaskAllocation,addUser,DailyToken,DailyTokenItem, TaskDayToken } from '../../shared/misc-classes';

@Component({
  selector: 'app-man-pwr-allctn',
  templateUrl: './man-pwr-allctn.component.html',
  styleUrls: ['./man-pwr-allctn.component.css']
})
export class ManPwrAllctnComponent implements OnChanges{

  @Input()currMonthDtObj:Date;
  @Input()tskAllctn:TaskAllocation;
  WorkDayTokenObj:TaskDayToken;

  constructor(public _dataService:DataService) { }

  ngOnChanges() {
    if(this._dataService.manPowerAllctn){
       this.loadDateData()
    }
  }
  checkDate(sel,cur){
    return sel.getDate()==cur.getDate() && sel.getMonth() == cur.getMonth() && sel.getFullYear() == cur.getFullYear()
  }
  loadDateData():void{
    var isFound = false;
    let _tmpDPHDayToken:TaskDayToken= new TaskDayToken(null,[]);
    if(this.tskAllctn){
      for(var i=0;i<this.tskAllctn.dayTokens.length;i++){
        if(this.checkDate(this.tskAllctn.dayTokens[i].selDate,this.currMonthDtObj)){
          isFound = true;
          _tmpDPHDayToken = this.tskAllctn.dayTokens[i]
        }
      }
    }    
    if(!isFound){
      _tmpDPHDayToken.selDate = this.currMonthDtObj;
      _tmpDPHDayToken.clearDayToken = [];
      for(var j=0;j<this._dataService.manPowerAllctn.workCategories.length;j++){
          var _wrk = this._dataService.manPowerAllctn.workCategories[j];
            for(var k=0;k<_wrk.task.length;k++){
              _tmpDPHDayToken.addToken(new TaskLinked(_wrk.workCategoryId,_wrk.workCategoryName,_wrk.task[k].taskId,_wrk.task[k].taskName,[],''))
            }
      }
      
    }
     this.WorkDayTokenObj = _tmpDPHDayToken;
  }

  checkLength(ind,lng){
    if(ind+1 < lng){
      return true
    }
    else {
      return false
    }
  }
}
